<template>
  <div>
    <app-header-container>
      {{ $t('views.Dashboard.Documents.documents') }}
    </app-header-container>
    <template >
      <div class="documents__notification" v-if="staticDocuments && computedDocuments.length === 0">
        <div class="pa-1 text--center">
          {{ $t('views.Dashboard.Documents.noDocuments') }}
        </div>
      </div>

      <div class="documents__list">
        <div v-for="doc of computedDocuments"
             :key="doc.id">
          <div  v-if="doc.downloadUrl && !doc.iframe" class="documents__item_wrapper">
            <box clickable class="mt-1 d-flex align-center box" @click="openDoc(doc.downloadUrl)">
              <span class="icon-invoice icon--medium mr-1"></span>
              {{doc.content}}
            </box>
          </div>
          <div v-if="doc.iframe" class="documents__item_wrapper">
            <v-modal
              animation="fade"
              block-scroll
              theme="light-grey"
              class="documents__item_wrapper"
              handle-click-bg
              fitContent
              max-height='90vh'
            >
              <template v-slot:activator="{ on }" >
                <box class="mt-1 d-flex align-center box" clickable @click="on()">
                  <span class="icon-invoice icon--medium mr-1"></span>
                  {{ doc.content }}
                </box>
              </template>
<!--              <template v-slot:footer v-if="doc.downloadUrl">-->
<!--                <a href="doc.downloadUrl">-->
<!--                  {{ $t('views.Dashboard.Documents.download') }}-->
<!--                </a>-->
<!--              </template>-->
              <div class="d-flex justify-center mt-1 documents">
                <div class="documents__container">
                  <iframe :src="doc.downloadUrl" frameborder="0" width="100%" height="100%"></iframe>
                </div>
              </div>
            </v-modal>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AppHeaderContainer from '@/ui/layout/AppHeaderContainer'
import Box from '@/ui/slots/Box'
import vModal from '@/ui/modals/vModal'

import staticBaseUrl from '@/mixins/staticBaseUrl'
import reqCountry from '@/mixins/reqCountry'
import screen from '@/mixins/screen'
import getTranslate from '@/mixins/getTranslate'
import profile from '@/mixins/profile'
import forwardMoreOnMobile from '@/mixins/forwardMoreOnMobile'

// import documents from '../../../s3content/source/documents'

import { StaticDocumentsGQL } from '@/graphql/queries'

export default {
  components: {
    AppHeaderContainer,
    Box,
    vModal
  },

  apollo: {
    /**
     * @typedef StaticDocument
     * @property {string} StaticDocuments.content
     * @property {number | null} StaticDocuments.date
     * @property {string} StaticDocuments.downloadUrl
     * @property {boolean | null} StaticDocuments.iframe
     * @property {StaticDocumentShow}StaticDocuments.show
     */

    /**
     * @typedef StaticDocumentShow
     * @property {number[]} StaticDocuments.countries
     * @property {number[]} StaticDocuments.exceptCountries
     * @property {boolean | null} StaticDocuments.gold
     * @property {number[]} StaticDocuments.partners
     */

    /**
     * @returns {StaticDocument[]}
     */
    staticDocuments: {
      query: StaticDocumentsGQL,

      update: data => data.merchant.staticDocuments
    }
  },

  methods: {
    openDoc (link) {
      window.open(link, '_blank')
    }
  },
  mixins: [staticBaseUrl, reqCountry, screen, getTranslate, profile, forwardMoreOnMobile],
  computed: {
    computedDocuments () {
      const defaultCountryId = 2017370
      const reqCountryId = this.profile?.reqCountry?.id ?? defaultCountryId
      const isGoldShop = this.profile?.gold ?? false
      const partnerId = this.profile?.id ?? null

      const docs = this.staticDocuments

      if (!docs) {
        return []
      }

      return docs
        .filter(
          document => (
            document.show.countries.some(rc => rc === reqCountryId) || document.show.countries.length === 0
          )
        )
        .filter(
          document => (
            !document.show.exceptCountries.some(rc => rc === reqCountryId)
          )
        )
        .filter(
          document => (
            document.show.gold === null || document.show.gold === isGoldShop
          )
        )
        .filter(
          document => (
            document.show.partners.length === 0 || document.show.exceptCountries.some(rc => rc === partnerId)
          )
        )
    }
  }
}
</script>

<style lang="scss">
  .documents {
    width: 90vw;
    height: 90vh;

    &__container {
      width: 100%;
      height: 100%;
      padding-top: 2rem;
    }

    &__list{
      display: grid;
      gap: 1rem;
      grid-template-columns: repeat(1, 1fr);
      @include respond(tab-port){
        grid-template-columns: repeat(2, 1fr);
      }
    }

    &__item_wrapper{
      height: 100%;
    }

    &__notification {
      border-radius: $border-radius;
      border: 2px solid lighten($color-yellow, 15);
      background-color: lighten($color-yellow, 35);
    }
  }

  .box{
    height: 100%;
  }
</style>
